// extracted by mini-css-extract-plugin
export default {"panel":"ExplanationPanel_panel__XtZUw","nextButton":"ExplanationPanel_nextButton__tVtcC","nextRow":"ExplanationPanel_nextRow__A4C0N"};